import { FC } from 'react';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

interface UsageCardProps {
  title: string;
  icon: React.ElementType;
  value: string | number | undefined;
  iconBg: string;
  iconColor: string;
  borderColor: string;
  valueColor?: string;
  description?: string;
}
const UsageCard: FC<UsageCardProps> = ({
  title,
  icon: IconComponent,
  value,
  iconBg,
  iconColor,
  borderColor,
  valueColor = 'text-black',
  description,
}) => {
  return (
    <Card className='shadow-none'>
      <CardHeader className='pb-3'>
        <CardTitle className='text-md font-medium text-muted-foreground'>
          {title}
        </CardTitle>
        <div className='flex items-center gap-2'>
          <div
            className={`p-2 rounded-full ${iconBg} ${iconColor} border ${borderColor}`}
          >
            <IconComponent className='h-4 w-4' />
          </div>
          <span className={`text-2xl font-bold ${valueColor}`}>{value}</span>
        </div>
        {description && (
          <CardDescription className='text-sm'>{description}</CardDescription>
        )}
      </CardHeader>
    </Card>
  );
};

export default UsageCard;
